import type { FaireProductEntity } from "../../entity_types/product";

export const p_f8tptzemr3: FaireProductEntity = {
  token: "p_f8tptzemr3",
  type: "product",
  name: "14K Gold-Filled Enamel Heart with Evil Eye Statement Ring",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/d165f7754a5d9bfda853f8f893d8168b5e7ad5aab090badd253ecb9c244398c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ffb8f23d1b29161d0a796ac8b1b417629e2dcbedd785ad998750aca469fad87.jpeg",
    "https://cdn.faire.com/fastly/c37e89a1b0fb238576373fd2208c01911401fcbf30693fcb52301b60a7bc85a0.jpeg",
    "https://cdn.faire.com/fastly/c8e3214c7a0817d6c4541044df8787f10288773fbd3be6545fcf1cbd70155328.jpeg",
    "https://cdn.faire.com/fastly/9401575ae245e269a60effc3d216016503467ef1203e784e605013ad17a5908a.jpeg",
    "https://cdn.faire.com/fastly/4b64938296074ffd166304a27db0954fe3f37b6b69ca82ed79448911990f9b2a.jpeg",
    "https://cdn.faire.com/fastly/091fa2995befbeb751846198e2a3789ecf6e31d5cb9c62927b444be9771d0388.jpeg",
    "https://cdn.faire.com/fastly/1e2db857071907af528bbcf959ca16bc2278d394e1be4487a22845d2695e52b4.jpeg",
  ],
  priceDollars: 7.66,
  description:
    "4K Gold Filled Enamel Heart with Evil Eye Adjustable Ring, Colored CZ Micro Pave Heart Ring, Evil Eye Ring, Heart Ring, Cubic Zirconia.\n\nUsage: This ring is a perfect finding for DIY jewelry making and can be used in many different ways and designs.\n\nMaterial: Brass, 14k Gold Filled, Cubic Zirconia, Enamel.\nMetal Finish Color: Gold.\nSize: 16x14mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nPlease make sure to choose the color of your choice from the options menu.\n\nIf you have any questions regarding our products, bulk discount, and issue, please send us a message.\nThank you for your visit!",
  tags: [],
  msrpDollars: 9.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:58.037Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
